import fp from 'lodash/fp';
import { CpdCategoryStatus } from '../constants/area-of-advice';
export const filterNonLegacy = fp.filter(({ legacy }) => !legacy);

export const filterNonRmGoalCategory = (cpdCategoryIdsWithRmGoal) =>
  fp.filter(({ id }) => !cpdCategoryIdsWithRmGoal.includes(id));

export const filterNonLegacyOrPublisherVisible = fp.filter(
  ({ legacy, publisherVisible }) => !legacy || publisherVisible
);

export const filterActiveStatus = fp.filter(({ status }) => status === CpdCategoryStatus.active);


// WEBPACK FOOTER //
// ./src/common/cpd-category-filter.js